import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react";

import { useParams } from "react-router-dom";

import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";

import {
	PrimaryNavLinks,
	NavigationItemTwo,
	LiveEventSideMenuSportsList,
	SubMenuList,
} from "./components";

export const LiveEventSideMenu = observer(function LiveEventSideMenu() {
	const { culture, eventIds } = useParams<{
		culture: string;
		eventIds: string;
	}>();
	const liveEventMenuViewStore = useContext(LiveEventSideMenuContext);

	useEffect(() => {
		liveEventMenuViewStore.onInitialize();
		return () => liveEventMenuViewStore.onDispose();
	}, []);

	useEffect(() => {
		liveEventMenuViewStore.setSelectedEventIds(eventIds);
	}, [eventIds]);

	return (
		<>
			<nav className="nav--secondary nav--live">
				<ul className="nav--secondary__menu nav--live__menu">
					<PrimaryNavLinks culture={culture} />
					<LiveEventSideMenuSportsList
						sportsList={
							liveEventMenuViewStore.eventsInSports.sports
						}
					/>
					<NavigationItemTwo culture={culture} />
				</ul>
			</nav>
			{liveEventMenuViewStore.isMenuExpanded && (
				<nav id="side-menu" className="nav--tertiary">
					<ul className="nav--tertiary__menu">
						<li className="nav--tertiary__item">
							<ul className="nav--quaternary">
								<SubMenuList
									culture={culture}
									eventOfferList={
										liveEventMenuViewStore.elementSubMenu
									}
									lookupsStore={
										liveEventMenuViewStore.lookupsStore
									}
								/>
							</ul>
						</li>
					</ul>
				</nav>
			)}
		</>
	);
});
